<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    id?: string;
}>();
</script>

<template>
    <h3
        :id="id"
        data-slot="card-title"
        :class="cn('font-semibold', id && 'relative group/heading scroll-mt-20 -ml-4 pl-4', props.class)"
    >
        <a
            v-if="id"
            :href="`#${id}`"
            class="absolute left-0 top-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover/heading:opacity-100 text-muted-foreground text-sm font-normal no-underline select-none"
            aria-hidden="true"
            tabindex="-1"
        >#</a>
        <slot />
    </h3>
</template>
